import { useEffect } from 'react';

// Calls onClose on a mousedown whose target lands outside ref.current, while active.
// extraRef is also treated as "inside" when given - for a trigger whose popover
// content is rendered via a portal (e.g. SearchableSelect's dropdown, portaled to
// document.body to escape a scrollable modal ancestor), the popover's DOM lives
// outside ref's own subtree, so without this a click inside it would count as
// "outside" and close before the click's own handler (e.g. selecting an option) runs.
export function useClickOutside(ref, active, onClose, extraRef) {
  useEffect(() => {
    if (!active) return;
    function handleClickOutside(event) {
      if (ref.current && ref.current.contains(event.target)) return;
      if (extraRef?.current && extraRef.current.contains(event.target)) return;
      onClose();
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [active, ref, extraRef, onClose]);
}
